import { NTHFlag } from '../constants/flag';
import { SocieteModel } from '../models/simple-types/societe.model';
import { Ca1Model } from '../models/societe-linked/ca1.model';
import { FournisseurModel } from '../models/societe-linked/fournisseur.model';
import { SiteModel } from '../models/societe-linked/site.model';
import { UtilisateurModel } from '../models/utilisateur/utilisateur.model';

export class FilterBpDTO {
  public idSociete: number = null;

  public societe: SocieteModel = null;
  public bpCa1: Ca1Model = null;
  public bpCa2: Ca1Model = null;
  public startNa: string = "";
  public endNa: string = "";
  startChantier: string = "";
  endChantier: string = "";
  public startDBp: Date = null;
  public endDBp: Date = null;
  public bpSite: SiteModel = null;
  public bpFourn: FournisseurModel = null;
  public refFourn: string = null;
  public libelleFourn: string = "";
  public startBpNum: string = "";
  public endBpNum: string = "";
  public status: string[] = ['Rapproché', 'En litige', 'Clos'];
  public facture: string = null;

  startDFactBp: Date = null;
  endDFactBp: Date = null;

  public startBcNum: string = "";
  public endBcNum: string = "";
  public bFacture: boolean[] = [true, false];
  public fValide: NTHFlag[] = [0, 1, 2];
  public bAnnule: boolean[] = [true, false];
  public bBloque: boolean[] = [true, false];

  public idCreateur: number = null; // id créateur du Bp
  public idValidateur: number = null; // id validateur du Bp

  public type: string = null;

  public descending = false;
  public pageNumber = 0;
  public pageSize = 25;
  public order = 'dBp';
}
